import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import styled from 'styled-components'

export const ReferralMainWrapper = styled.div<{ windowWidth: number }>`
  display: flex;
  align-content: center;
  justify-content: center;
  flex-direction: column;
  margin: ${({ windowWidth }) =>
    windowWidth < 768 ? ' 2em' : windowWidth < 480 ? '1em' : '8em'};
`

export const ReferralBanner = styled.div`
  display: flex;
  justify-content: space-between;
  background: linear-gradient(
    90deg,
    rgba(34, 117, 255, 1) 0%,
    rgba(236, 50, 177, 1) 100%
  );
  border-radius: 20px;
  height: 150px;
  margin-bottom: 0.5em;
`

export const ReferralBannerTextWrapper = styled.div`
  width: 60%;
  display: flex;
  align-items: center;
`

export const ReferralBannerText = styled.h2<{ windowWidth: number }>`
  font-size: ${({ windowWidth }) => (windowWidth < 500 ? '1.4em' : '1.7em')};
  color: #fff;
  font-family: 'proxima-nova', sans-serif;
  padding: 20px;
  text-align: left;
  font-weight: 700;
  white-space: pre-wrap;
  letter-spacing: 0.08em;
`

export const ReferralBannerImage = styled.img<{ windowWidth: number }>`
  height: ${({ windowWidth }) => (windowWidth < 500 ? '130px' : '240px')};
  margin-top: ${({ windowWidth }) => (windowWidth < 500 ? '16px' : '-90px')};
`

export const ReferralStepsWrapper = styled.div`
  display: flex;
  flex-direction: column;
`

export const StepWrapper = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  border: 1px solid #e9e9eb;
  border-radius: 20px;
  background: #f9fafc;
  padding: 20px;
  margin: 0.5em 0;
`

export const CopyContainer = styled.div<{ windowWidth: number }>`
  display: flex;
  flex-direction: ${({ windowWidth }) =>
    windowWidth < 500 ? 'column' : 'row'};
  align-items: center;
`

export const CopyLinkInput = styled.input<{ windowWidth: number }>`
  height: 55px;
  background: #ffffff;
  color: #9a989e;
  border: 1px dashed #9a989e;
  padding: 12px;
  border-radius: 8px;
  user-select: text;
  margin: ${({ windowWidth }) =>
    windowWidth < 500 ? '0 0 4px 0' : '0 8px 0 0'};
  &:hover {
    cursor: text;
  }
`

export const CopyButton = styled.button<{ windowWidth: number }>`
  background: #345dd4;
  border-radius: 10px;
  border: none;
  padding: 8px;
  width: 160px;
  height: 45px;
  margin: ${({ windowWidth }) => (windowWidth < 500 ? '4px 0' : '0 8px')};
  &:hover {
    cursor: pointer;
    background: #2e55bf;
  }
`

export const CopyButtonIcon = styled(FontAwesomeIcon)`
  color: #fff;
  margin: 0 8px;
`

export const CopyButtonContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
`

export const CopyButtonText = styled.p`
  font-size: 1em;
  font-family: 'proxima-nova', sans-serif;
  color: #fff;
  letter-spacing: 0.02em;
  white-space: pre-wrap;
  font-weight: 700;
  margin: 0;
`

export const CopyMessage = styled.div<{ isVisible: boolean }>`
  position: relative;
  height: 30px;
  display: flex;
  border-radius: 6px;
  width: 70px;
  background: #0b1226;
  color: #fff;
  justify-content: center;
  align-items: center;
  margin: auto 0;
  opacity: ${isVisible => (isVisible ? 1 : 0)};
  transition: opacity 2s ease-in-out;

  ::before {
    content: '';
    position: absolute;
    top: 50%;
    left: -6px;
    transform: translateY(-50%);
    width: 0;
    height: 0;
    border-top: 10px solid transparent;
    border-bottom: 10px solid transparent;
    border-right: 10px solid #0b1226;
  }
`

export const CopyMessageText = styled.p`
  font-size: 0.75em;
  font-family: 'proxima-nova', sans-serif;
  color: #fff;
  margin: 0;
  font-weight: 700;
`

export const ButtonsContainer = styled.div<{ windowWidth: number }>`
  display: flex;
  flex-direction: ${({ windowWidth }) =>
    windowWidth < 500 ? 'column' : 'row'};
  margin: 1em 0;
`

export const ShareIcon = styled(FontAwesomeIcon)`
  color: #868686;
  margin-right: 8px;
  font-size: 19px;
`

export const ShareText = styled.p`
  color: #868686;
  font-size: 1em;
  font-family: 'proxima-nova', sans-serif;
  letter-spacing: 0.02em;
  white-space: pre-wrap;
  margin: 0;
`

export const ShareButton = styled.button<{ windowWidth: number }>`
  background: #fff;
  border: 1px solid #e9e9eb;
  padding: 12px;
  border-radius: 10px;
  margin: ${({ windowWidth }) =>
    windowWidth < 500 ? '4px 0 4px 0' : '0 8px 0 0'};

  &:hover {
    cursor: pointer;
    background: rgba(52, 92, 212, 0.7);

    ${ShareIcon}, ${ShareText} {
      color: #fff;
    }
  }
`

export const ShareButtonContainer = styled.div`
  display: flex;
  justify-content: center;
  align-content: center;
  align-items: center;
`

export const StepsHeading = styled.p`
  font-size: 1em;
  color: #393841;
  font-family: 'proxima-nova', sans-serif;
  letter-spacing: 0.02em;
  white-space: pre-wrap;
  font-weight: 700;
  margin: 1em 0;
`

export const StepsHighlightText = styled.span`
  color: #345dd4;
  font-weight: bold;
`

export const HorizontalLine = styled.hr`
  border-top: 1px solid #e9e9eb;
  width: 100%;
`
